export default "__VITE_ASSET__BPPwuGdN__"